import React from 'react';

import { Box, IconButton, Text } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

type Props = {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  numberOfPages: number;
  css?: SystemStyleObject;
};

export const Paginator: React.FC<Props> = ({ currentPage, setCurrentPage, numberOfPages, css }) => {
  return (
    <Box css={{ ...css }}>
      <Box css={{ display: 'flex' }}>
        <IconButton
          label="previous page"
          name="CaretLeft"
          variant="ghostPrimary"
          spacing="none"
          onClick={() => setCurrentPage(currentPage - 1)}
          css={{ visibility: currentPage > 1 ? 'visible' : 'hidden' }}
        >
          Previous
        </IconButton>
        <Text css={{ display: 'inline-block', mt: 'space.25' }}>
          {currentPage} of {numberOfPages}
        </Text>
        <IconButton
          label="next page"
          name="CaretRight"
          variant="ghostPrimary"
          spacing="none"
          onClick={() => setCurrentPage(currentPage + 1)}
          css={{ visibility: currentPage < numberOfPages ? 'visible' : 'hidden' }}
        >
          Next
        </IconButton>
      </Box>
    </Box>
  );
};
